<template>
  <div style="height: 100%; color: #FAFAFA;">
    <label style="padding: 20px 0px 10px 30px;">空调设备</label>
    <div v-if="deviceDataList.length > 0" style="height: 85%">
      <!-- 2个及以下设备直接显示 -->
      <template v-if="pageList.length === 1">
        <el-row style="height: 100%;">
          <el-col :span="12" v-for="device in pageList[0]" :key="device.deviceName" class="text-center">
            <el-row>
              <label :style="{ lineHeight: '3vh', color: (device.status !== undefined && device.status !== 0) ? '#ff0000' : '#fff' }">
                {{ device.deviceName }}
              </label>
            </el-row>
            <el-row style="margin-top: 1vh;">
              <el-col :span="10" class="text-right text-blueGrey">回风温度：</el-col>
              <el-col :span="6" class="text-left" style="margin-left: 10px;">{{ device.temperature }}℃</el-col>
            </el-row>
            <el-row style="margin-top: 1vh;">
              <el-col :span="10" class="text-right text-blueGrey">回风湿度：</el-col>
              <el-col :span="6" class="text-left" style="margin-left: 10px;">{{ device.humidity }}%</el-col>
            </el-row>
            <el-row style="margin-top: 1vh;">
              <el-col :span="10" class="text-right text-blueGrey">制冷状态：</el-col>
              <el-col :span="6" class="text-left" style="margin-left: 10px;">{{ device.coolingStatus }}</el-col>
            </el-row>
            <el-row style="margin-top: 1vh;">
              <el-col :span="10" class="text-right text-blueGrey">加湿状态：</el-col>
              <el-col :span="6" class="text-left" style="margin-left: 10px;">{{ device.humidificationStatus }}</el-col>
            </el-row>
          </el-col>
        </el-row>
      </template>
      <!-- 超过2个设备使用轮播 -->
      <template v-else>
        <el-carousel 
          :interval="10000" 
          indicator-position="none" 
          :autoplay="true" 
          style="height: 100%; z-index: 0">
          <el-carousel-item v-for="(page, index) in pageList" :key="index">
            <el-row style="height: 100%;">
              <el-col :span="12" v-for="device in page" :key="device.deviceName" class="text-center">
                <el-row>
                  <label :style="{ lineHeight: '3vh', color: (device.status !== undefined && device.status !== 0) ? '#ff0000' : '#fff' }">
                    {{ device.deviceName }}
                  </label>
                </el-row>
                <el-row style="margin-top: 1vh;">
                  <el-col :span="10" class="text-right text-blueGrey">回风温度：</el-col>
                  <el-col :span="6" class="text-left" style="margin-left: 10px;">{{ device.temperature }}℃</el-col>
                </el-row>
                <el-row style="margin-top: 1vh;">
                  <el-col :span="10" class="text-right text-blueGrey">回风湿度：</el-col>
                  <el-col :span="6" class="text-left" style="margin-left: 10px;">{{ device.humidity }}%</el-col>
                </el-row>
                <el-row style="margin-top: 1vh;">
                  <el-col :span="10" class="text-right text-blueGrey">制冷状态：</el-col>
                  <el-col :span="6" class="text-left" style="margin-left: 10px;">{{ device.coolingStatus }}</el-col>
                </el-row>
                <el-row style="margin-top: 1vh;">
                  <el-col :span="10" class="text-right text-blueGrey">加湿状态：</el-col>
                  <el-col :span="6" class="text-left" style="margin-left: 10px;">{{ device.humidificationStatus }}</el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-carousel-item>
        </el-carousel>
      </template>
    </div>
    <div v-else style="height: 100%; padding-top: 20%">
      <no-data></no-data>
    </div>
  </div>
</template>

<script>
import NoData from "@/components/NoData";
import { getSpecialTypeValues } from "@/network/measuring-point-history";

export default {
  name: "controlRoomAirConditionerBar",
  components: { NoData },
  data() {
    return {
      deviceDataList: [],
      pageList: [],
      pageSize: 2, // 每页显示2个设备
      deviceType: 'PM_AC', // 精密空调类型
      pointCodes: 'tcv,hv,make_cold,add_hum' // 回风温度,回风湿度,制冷状态,加湿状态
    };
  },
  mounted() {
    this.getData();
  },
  created() {
    this.$store.dispatch('addIntervalObj', { 'getAirConditionerBarData:10000': this.getData })
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getAirConditionerBarData')
  },
  methods: {
    getData() {
      getSpecialTypeValues(this.deviceType, this.pointCodes).then(res => {
        if (res.code === 0 && res.data) {
          const { devices, devicePointValues } = res.data;
          if (devices && devices.length > 0) {
            this.deviceDataList = this.processData(devices, devicePointValues);
            if (this.deviceDataList.length > 0) {
              this.pageList = this.chunkData(this.deviceDataList, this.pageSize);
            } else {
              this.pageList = [];
            }
          } else {
            this.deviceDataList = [];
            this.pageList = [];
          }
        } else {
          this.deviceDataList = [];
          this.pageList = [];
        }
      }).catch(() => {
        this.deviceDataList = [];
        this.pageList = [];
      });
    },
    // 处理接口返回的数据
    processData(devices, devicePointValues) {
      const result = [];
      for (let i = 0; i < devices.length; i++) {
        const device = devices[i];
        const values = devicePointValues[i];
        if (device && values) {
          let coolingText = '--';
          if (values[2] == 0) coolingText = '关';
          else if (values[2] == 1) coolingText = '开';
          else if (values[2] != null) coolingText = values[2];

          let humidificationText = '--';
          if (values[3] == 0) humidificationText = '关';
          else if (values[3] == 1) humidificationText = '开';
          else if (values[3] != null) humidificationText = values[3];

          result.push({
            deviceName: device.name || '未知设备',
            status: device.status,
            temperature: values[0] != null ? values[0] : '--',
            humidity: values[1] != null ? values[1] : '--',
            coolingStatus: coolingText,
            humidificationStatus: humidificationText
          });
        }
      }
      return result;
    },
    // 将数据分页
    chunkData(data, size) {
      const result = [];
      for (let i = 0; i < data.length; i += size) {
        result.push(data.slice(i, i + size));
      }
      return result;
    }
  }
}
</script>

<style scoped>
label {
  font-weight: bold;
  color: #01EFFD;
}

.el-carousel >>> .el-carousel__arrow {
  top: 5%;
}
</style>

